import logo from "../images/logo.svg";

const Navbar = () => {
  return (
    <nav className="flex bg-[#F7F9FC] w-full text-[#1D58E2] font-inter font-medium">
      <div className='flex px-4 py-2 sm:px-6 sm:py-3 lg:px-10 lg:py-3 items-center justify-between max-[768px]:justify-center w-full max-w-[1700px] mx-auto'>
        <img
          src={logo}
          alt="logo"
          className="h-10 sm:h-12 lg:h-16 w-auto sm:w-[200px] lg:w-[260px]"
          style={{ objectFit: "fill" }}
        />
        <div className="flex items-center gap-3 max-[768px]:hidden">
          <p className="text-sm px-6 text-[#1B2559] font-normal">
            Already have an account?{" "}
            <a
              href={process.env.REACT_APP_DASHBOARD_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="text-[#1D58E2] font-semibold hover:underline"
            >
              Sign In
            </a>
          </p>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
